export const RAINBOW_COLORS = [
  '#8EB5FF',
  '#8EFFC9',
  '#B28EFF',
  '#D4FF8E',
  '#FF8E8E',
  '#FF8EF4',
  '#FFD28E'
];
